import { render, staticRenderFns } from "./Teatros.vue?vue&type=template&id=bcabdd88"
import script from "./Teatros.vue?vue&type=script&lang=js"
export * from "./Teatros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports